import Search from 'components/commons/search'
import Sort from 'components/commons/sort'
import PageLimit from 'components/commons/page-limit'
import { Button } from 'avo-ui'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import Table from 'components/commons/table'
import ModalExport from 'components/commons/modal-export'
import { SORT_CUSTOMER, INITIAL_DATA_FILTER, TABLE_CUSTOMER } from 'configs/analytics/configTableCustomer'
import moment from 'moment/moment'
import DateRangePicker from 'components/commons/date-range-picker'
import { AdvanceFilterContainer } from '../../../containers/analytics/customer/AdvanceFilterContainer'

export const Customer = ({
    dataList,
    query,
    onChangeQuery,
    queryFilter,
    onFilter,
    modal,
    setShowModal,
    onSelectSort,
    isLoadingList,
    isLoadingExport,
    onExport,
}) => {
    const initDate = [INITIAL_DATA_FILTER?.start_date, INITIAL_DATA_FILTER?.end_date]

    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-y-3 space-x-3 flex-wrap'}>
                <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                <DateRangePicker
                    value={query?.start_date ? [query?.start_date, query?.end_date] : initDate}
                    onChange={(value) =>
                        onChangeQuery({
                            ...INITIAL_DATA_FILTER,
                            start_date: value[0] || initDate[0],
                            end_date: value[1] || initDate[1],
                        })
                    }
                    maxDate={moment()}
                    format={'YYYY-MM-DD'}
                />
                <Sort
                    options={SORT_CUSTOMER}
                    value={`${query?.order_by}_${query?.order_type}`}
                    onSelect={(value) => onSelectSort(value)}
                />
                <AdvanceFilterContainer
                    show={modal?.filter}
                    setShow={(value) => setShowModal({ filter: value })}
                    values={queryFilter}
                    onSubmit={(value) => onFilter(value)}
                />
                <PageLimit value={query?.limit} onSelect={(value) => onChangeQuery({ page: 1, limit: value })} />
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    disabled={!dataList?.total_result}
                    onClick={() => setShowModal({ export: true })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_CUSTOMER.name}
                columns={TABLE_CUSTOMER.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoadingList}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={dataList?.total_result}
                    isLoading={isLoadingExport}
                    onExport={onExport}
                />
            )}
        </div>
    )
}
